import { iconA11y, type IconProps } from './iconProps';

export function HamburgerIcon({ size = 24, title, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...iconA11y(title)}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M4 7h16M4 12h16M4 17h16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
